import React from 'react';
import { STAT_KEYS, STAT_META } from '../data/constants';
import { useI18n } from '../i18n';

const STAT_ICON = {
  e: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"
         strokeLinecap="round" strokeLinejoin="round">
      <path d="m8 6-6 6 6 6" />
      <path d="m16 6 6 6-6 6" />
    </svg>
  ),
  x: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"
         strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 21h18M5 21V10l7-5 7 5v11M9 21v-6h6v6" />
    </svg>
  ),
  u: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"
         strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="8" r="3.5" />
      <path d="M5 21c0-4 3-7 7-7s7 3 7 7" />
    </svg>
  ),
  p: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"
         strokeLinecap="round" strokeLinejoin="round">
      <path d="M13 2 4 14h7l-1 8 9-12h-7z" />
    </svg>
  ),
};

function StatBar({ k, value, accent, pulse }) {
  const { ts } = useI18n();
  const meta = ts(k);
  const color = STAT_META[k].color;
  return (
    <div className={'stat' + (pulse ? ' stat--pulse' : '')} title={meta.label}>
      <div className="stat__icon" style={{ color: accent }}>{STAT_ICON[k]}</div>
      <div className="stat__bar">
        <div className="stat__fill" style={{ width: `${value}%`, background: color }} />
      </div>
    </div>
  );
}

export default function StatRow({ stats, accent, pulse }) {
  return (
    <div className="statrow">
      {STAT_KEYS.map((k) => (
        <StatBar key={k} k={k} value={stats[k]} accent={accent} pulse={pulse[k]} />
      ))}
    </div>
  );
}
